export class AccountDelete {
    public myAccountLink: string;
    public faqLink: string;
    public hasConfirmedDataDeletion: boolean;
}
